module.exports = __webpack_public_path__ + "img/electronicLk1.f4c55d5c.png";